function addSpanTag(headingElement) {
    // Add a span tag to the first word of an element's text
    var headingwords = headingElement.text().trim().split(" ");
    headingElement.empty();
    jQuery.each(headingwords, function (i, v) {
        if (i == 0) {
            // wrap first word in span tags
            headingElement.append(jQuery('<span class="logo-small">').text(v));
        } else {
            headingElement.append(" " + v);
        }
    });
}
function isExperienceEditor() {
    return (typeof Sitecore !== "undefined" && Sitecore && Sitecore.PageModes && Sitecore.PageModes.PageEditor);
}

jQuery(document).ready(function () {
    var mobileNavSlideSpeed = 500;
    
    // Add a span tag in the site logo to allow different-sized fonts (skip in editor)
    if (!isExperienceEditor()) {
        addSpanTag(jQuery('span.site-logo span.menu-item-text'));
    }
    
    // Mobile menu functions
    jQuery(".mobile-nav-toggle").click(function(e){
		e.preventDefault();
		jQuery('#main-navbar .tech-menu').toggle();
        jQuery('#main-navbar').toggleClass('mobile-active');
        jQuery('body').toggleClass('overlay');
	});
    jQuery(".expandable > a > i").click(function(e){
		// see if there are child nav items for this item
		var children = jQuery(this).parent().parent('li').find('> .sub-menu');

		// if the item has child items, reveal them (toggle expanded class), otherwise treat as a normal link
		if(children.length > 0) {
			e.preventDefault();
			children.slideToggle(mobileNavSlideSpeed);
			jQuery(this).parent().parent('li').toggleClass('expanded');
		}
	});
    
    // Active item functions
    jQuery("section.gallery .gallery-expand-trigger").click(function(e) {
        jQuery(this).toggleClass('active');
        jQuery(this).attr('aria-expanded', function(i, attr) {
            return attr == 'true' ? 'false' : 'true' 
        });
    });
    jQuery("section.partners .partner-expand-trigger").click(function(e) {
        jQuery(this).toggleClass('active');
        jQuery(this).attr('aria-expanded', function(i, attr) {
            return attr == 'true' ? 'false' : 'true' 
        });
    })
    jQuery("section.our-spaces .space-expand-trigger").click(function(e) {
        jQuery(this).parent().parent(".gallery-list").find(".space-expand-trigger").not(this).parent(".gallery-item").removeClass("initial-select").removeClass('active');
        jQuery(this).parent(".gallery-item").toggleClass('active');
    });
    jQuery("section.events .event-expand-trigger").click(function(e) {
        jQuery(this).parent().parent(".event-list").find(".event-expand-trigger").not(this).parent(".event-item").removeClass("initial-select").removeClass('active');
        jQuery(this).parent(".event-item").toggleClass('active');
    });
    jQuery(".event-item, .program-item, .gallery-item").mouseover(function(e) {
        jQuery(this).parent('ul').find('li.initial-select').removeClass('initial-select');
    });
});

/**** Keyboard control ****/


keyboardControl = function (e) {
    var currentItem = jQuery(this);
    var currentItemKeyControl = currentItem.data("keyControl");

    // handle relevent key press if the item has functionality for that key
    switch(e.which) {
        case 40: // arrow down
            if( jQuery.isFunction(currentItemKeyControl.down)) { currentItemKeyControl.down(e, currentItem) };
        break;

        case 38: // arrow up
            if( jQuery.isFunction(currentItemKeyControl.up)) { currentItemKeyControl.up(e, currentItem) };
        break;

        case 9: // tab
            if( jQuery.isFunction(currentItemKeyControl.tab)) { currentItemKeyControl.tab(e, currentItem); };
        break;

        case 13: // enter
            if( jQuery.isFunction(currentItemKeyControl.enter)) { currentItemKeyControl.enter(e, currentItem) };
        break;

        case 27: // esc
            if( jQuery.isFunction(currentItemKeyControl.esc)) { currentItemKeyControl.esc(e, currentItem) };
        break;

        default:

        break;
    }

    return;
};

// add keyboard navigation for main menu
jQuery(".top-menu > li:not(.home) > a").data("keyControl", {
    tab: function(e, $this) {
        // run if shift button isn't pressed - if it is, default behaviour is good
        if(!e.shiftKey) {
            var nextItem = $this.parent().next("li").find("> a");

            if(nextItem.length > 0) {
                e.preventDefault();
                nextItem.focus();
            } else {
                // leaving menu, remove any active sub-menu
                jQuery(".top-menu > li").removeClass("active");
                if(jQuery(".top-menu > li.expandable").attr('aria-expanded')) {
                    jQuery(".top-menu > li.expandable").attr('aria-expanded', 'false');
                }
            }
        }

    },
    down: function(e, $this) {
        e.preventDefault();
        $this.parent().addClass("active");
        // go to child menu
        var childItem = $this.parent().find(".sub-menu li a").first();
        if(childItem.length > 0) {
            e.preventDefault();
            childItem.focus();
        }

    },
    up: function(e, $this) {
        e.preventDefault();
        $this.parent().addClass("active");
        // go to child menu
        var childItem = $this.parent().find(".sub-menu li a").last();
        if(childItem.length > 0) {
            e.preventDefault();
            childItem.focus();
        }

    }
}).keydown(keyboardControl);

// add active class to the current focused item to open mega menu
jQuery(".top-menu > li:not(.home) > a").focusin(function(e){
    jQuery(this).parent().parent().find("li").removeClass("active");

    var $listItem = jQuery(this).parent();
    $listItem.addClass("active");
});

// hide the keyboard activated nav when other elements are in focus
jQuery("li.home a").focusin(function(e){
    jQuery(".top-menu > li").removeClass("active");
    if(jQuery(".top-menu > li.expandable").attr('aria-expanded')) {
        jQuery(".top-menu > li.expandable").attr('aria-expanded', 'false');
    }

});

// 	main nav child items
jQuery(".sub-menu li a").data("keyControl", {
    down: function(e, $this) {
        e.preventDefault();

        // next item
        var nextItem = $this.parent().next("li").find("> a");

        if(nextItem.length > 0) {
            e.preventDefault();
            nextItem.focus();
        } else {
            // doesn't seem to be any more items, go back to main link
            $this.parentsUntil(".sub-menu").parent().parent().find("a").first().focus();

            return;
        }
    },
    up: function(e, $this) {
        e.preventDefault();
        // previous item
        var prevItem = $this.parent().prev("li").find("> a");
        
        if(prevItem.length > 0) {
            e.preventDefault();
            prevItem.focus();
        } else {
            // no previous item, go back to main link
            $this.parentsUntil(".sub-menu").parent().parent().find("a").first().focus();
        }

        return;
    },
    tab: function(e, $this) {
        // go to next main nav item
        jQuery(".top-menu > li").removeClass("active");
        $this.parentsUntil(".sub-menu").parent().next("li").focus();
        
        return;
    },
    esc: function(e, $this) {
        // go to this sections main nav item
        $this.parentsUntil(".sub-menu").parent().prev().focus();
        return;
    }
}).keydown(keyboardControl);

/**** End keyboard control ****/